// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"MxZtG+DGCu2s8P5D88SLjw==","icon":"_8oTrJX+gpR4QF3jXsFJlOg==","unreadMessages":"_1laCkrepZK6K2m7Wzt5KEw=="};